import React, { useEffect, useState } from 'react';
import api from '../api';
import axios from 'axios';
import WorkshopSelection from '../components/WorkshopSelection';
import { calcWorkshopFee, formatIdr, findWorkshopLabel } from '../utils/workshopPricing';

const PesertaInfoEvent = () => {
  const apiUrl = process.env.REACT_APP_API_ENDPOINT;
  const [events, setEvents] = useState([]);
  const [audienceCategories, setAudienceCategories] = useState([]);
  const [hotels, setHotels] = useState([]);
  const [accomodationHotels, setAccomodationHotels] = useState([]);
  const [typeKamarOptions, setTypeKamarOptions] = useState([]);
  const [accomodations, setAccomodations] = useState([]);
  const [eventPrices, setEventPrices] = useState([]);
  const [error, setError] = useState("");

  const [categoryDetails, setCategoryDetails] = useState([]);
  const [workshopCatalog, setWorkshopCatalog] = useState({ sabtu: [], minggu: [], prices: { one: 1199000, two: 1999000 } });

  const [page, setPage] = useState(0);
  const [size, setSize] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [searchTerm, setSearchTerm] = useState('');
  const [showJoinModal, setShowJoinModal] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [form, setForm] = useState({
    nama: "",
    namaLengkapGelar: "",
    nik: "",
    hp: "",
    email: "",
    audienceCategory: "",
    audienceCategoryDetail: "",
    asalInstitusi: "",
    eventPrice: "",
    workshopSabtuId: "",
    workshopMingguId: "",
    password: "",
    confirmPassword: "",
  });
  const [pesertaList, setPesertaList] = useState([]);

  useEffect(() => {
    fetchEvents();
  }, [page, size, searchTerm]);

  const fetchEvents = () => {
    let url = `${apiUrl}/api/events/not-joined?page=${page}&size=${size}`;
    if (searchTerm) {
      url += `&search=${searchTerm}`;
    }
    api.get(url)
      .then(res => {
        setEvents(res.data.content);
        setTotalPages(res.data.totalPages);
      })
      .catch(err => {
        console.error('Error fetching events:', err);
      });
  };

  const handleSearch = (e) => {
    e.preventDefault();
    setPage(0);
    fetchEvents();
  };

  const setPageListItems = (event) => {
    const value = parseInt(event.target.getAttribute('data-value'), 10);
    setSize(value);
    setPage(0);
  };

  const fetchLastPeserta = async () => {
    try {
      const res = await api.get(`${apiUrl}/api/peserta/last`);
      return res.data;
    } catch (err) {
      return null;
    }
  };



  const handleHotelChange = async (e) => {
    const hotelId = e.target.value;

    setForm(prev => ({ ...prev, hotel: hotelId, typeKamar: "", hargaKamar: "", keterangan: "" }));

    if (hotelId) {
      const res = await api.get(`${apiUrl}/api/public/get-hotel?hotelId=${hotelId}`);
      setAccomodations(res.data);

      // Ambil type kamar unik
      const typeKamarList = res.data
        .map(acc => acc.typeKamar)
        .filter((val, idx, arr) => val && arr.indexOf(val) === idx);
      setTypeKamarOptions(typeKamarList);
    } else {
      setAccomodations([]);
      setTypeKamarOptions([]);
    }
  };

  const handleTypeKamarChange = (e) => {
    const typeKamar = e.target.value;
    setForm(prev => ({ ...prev, typeKamar }));

    // alert(JSON.stringify(accomodations))
    // Cari data accomodation yang sesuai type kamar
    const selected = accomodations.find(acc => acc.typeKamar === typeKamar);
    if (selected) {
      setForm(prev => ({
        ...prev,
        hargaKamar: selected.hargaKamar,
        keterangan: selected.keterangan
      }));
    } else {
      setForm(prev => ({
        ...prev,
        hargaKamar: "",
        keterangan: ""
      }));
    }
  };

  const handleJoinClick = async (eventData) => {



    if (eventData.id) {
      const res = await api.get(`${apiUrl}/api/public/event-prices?eventId=${eventData.id}`);
      setEventPrices(res.data);
    } else {
      setEventPrices([]);
    }

    const res = await api.get(`/public/accomodation/get-event?eventId=${eventData.id}`);
    console.log('Accommodation data:', res.data);
    if (Array.isArray(res.data)) {
      setAccomodationHotels(res.data);
      console.log('Set accomodationHotels:', res.data);
    } else {
      setAccomodationHotels([]);
    }

    try {
      const res = await api.get(`/public/audience-category/by-event`, {
        params: { eventId: eventData.id, page: 0, size: 100 }
      });
      console.log('Audience category data:', res.data);
      if (res.data && Array.isArray(res.data.content)) {
        setAudienceCategories(res.data.content);
      } else {
        setAudienceCategories([]);
      }
    } catch (error) {
      console.error("Gagal mengambil data Audience Category:", error);
      setAudienceCategories([]);
    }

    setSelectedEvent(eventData);
    // Ambil data peserta terakhir
    const lastPeserta = await fetchLastPeserta();
    if (lastPeserta) {
      setForm({
        nama: lastPeserta.nama || "",
        namaLengkapGelar: lastPeserta.namaLengkapGelar || "",
        nik: lastPeserta.nik || "",
        hp: lastPeserta.hp || "",
        email: lastPeserta.email || "",
        asalInstitusi: lastPeserta.asalInstitusi || "",
        audienceCategory: lastPeserta.audienceCategoryId || "",
        eventPrice: lastPeserta.eventPriceId || "",
        akomodasiHotel: lastPeserta.akomodasiHotel ? "ya" : "tidak",
        hotel: lastPeserta.hotelId || "",
        typeKamar: lastPeserta.typeKamar || "",
        awalInap: lastPeserta.awalInap || "",
        akhirInap: lastPeserta.akhirInap || "",
        password: "",
        confirmPassword: "",
      });
    } else {
      setForm({
        nama: "",
        namaLengkapGelar: "",
        nik: "",
        hp: "",
        email: "",
        asalInstitusi: "",
        audienceCategory: "",
        eventPrice: "",
        akomodasiHotel: "tidak",
        hotel: "",
        typeKamar: "",
        awalInap: "",
        akhirInap: "",
        password: "",
        confirmPassword: "",
      });
    }
    setShowJoinModal(true);
  };

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleJoinSubmit = async (e) => {
    e.preventDefault();
    setShowConfirmModal(true);
  };

  // const handleConfirmJoinSubmit = async () => {
  //   try {
  //     let sequence = 0;
  //     const a = await api.get(`${apiUrl}/api/public/sequence`);
  //     sequence = a.data.nextValue;

  //     const today = new Date();
  //     const dd = String(today.getDate()).padStart(2, '0');
  //     const mm = today.getMonth() + 1; // 1-based
  //     const yyyy = today.getFullYear();

  //     function toRoman(num) {
  //       const roman = ["I", "II", "III", "IV", "V", "VI", "VII", "VIII", "IX", "X", "XI", "XII"];
  //       return roman[num - 1] || "";
  //     }
  //     const romanMonth = toRoman(mm);
  //     const paddedSequence = String(sequence).padStart(3, '0');
  //     const nomorRegistrasi = `${paddedSequence}/CIU-IDAIBanten/${romanMonth}/${yyyy}`;

  //     await api.post('/peserta/join', {
  //       nomorRegistrasi,
  //       eventId: selectedEvent.id,
  //       eventPriceId: form.eventPrice,
  //       nama: form.nama,
  //       namaLengkapGelar: form.namaLengkapGelar,
  //       nik: form.nik,
  //       audienceCategoryId: form.audienceCategory,
  //       audienceCategoryDetailId: form.audienceCategoryDetail,
  //       asalInstitusi: form.asalInstitusi,
  //       categoryEvent: form.categoryEvent,
  //       akomodasiHotel: form.akomodasiHotel === "ya",
  //       hotelId: form.akomodasiHotel === "ya" ? form.hotel : null,
  //       typeKamar: form.akomodasiHotel === "ya" ? form.typeKamar : null,
  //       hargaKamar: form.akomodasiHotel === "ya" ? form.hargaKamar : null,
  //       keterangan: form.akomodasiHotel === "ya" ? form.keterangan : null,
  //       hp: form.hp,
  //       email: form.email,
  //       password: form.password,
  //       sequence,
  //       awalInap: form.awalInap,
  //       akhirInap: form.akhirInap,
  //     });
  //     fetchEvents();
  //     alert(`Pendaftaran berhasil!\nNomor Registrasi Anda: ${nomorRegistrasi}\nCek email Anda untuk detail pendaftaran.`);
  //     setShowJoinModal(false);
  //     setShowConfirmModal(false);
  //   } catch (err) {
  //     alert('Pendaftaran gagal!');
  //     console.error(err);
  //   }
  // };

  const handleConfirmJoinSubmit = async () => {
    try {
      // Get sequence and event code from backend
      const response = await axios.get(`${apiUrl}/api/public/sequence-with-event-code/${selectedEvent.id}`);
      const { nextValue: sequence, nomorRegistrasi } = response.data;

      await api.post('/peserta/join', {
        nomorRegistrasi,
        eventId: selectedEvent.id,
        eventPriceId: form.eventPrice,
        nama: form.nama,
        namaLengkapGelar: form.namaLengkapGelar,
        nik: form.nik,
        audienceCategoryId: form.audienceCategory,
        audienceCategoryDetailId: form.audienceCategoryDetail,
        asalInstitusi: form.asalInstitusi,
        categoryEvent: form.categoryEvent,
        workshopSabtuId: form.workshopSabtuId ? Number(form.workshopSabtuId) : null,
        workshopMingguId: form.workshopMingguId ? Number(form.workshopMingguId) : null,
        hp: form.hp,
        email: form.email,
        password: form.password,
        sequence,
      });
      fetchEvents();
      alert(`Pendaftaran berhasil!\nNomor Registrasi Anda: ${nomorRegistrasi}\nCek email Anda untuk detail pendaftaran.`);
      setShowJoinModal(false);
      setShowConfirmModal(false);
    } catch (err) {
      alert('Pendaftaran gagal!');
      console.error(err);
    }
  }

  const handleEventChange = async (e) => {
    const eventId = e.target.value;
    setForm(prev => ({ ...prev, event: eventId, eventPrice: "" }));
    if (eventId) {
      const res = await api.get(`${apiUrl}/api/public/event-prices?eventId=${eventId}`);
      setEventPrices(res.data);
    } else {
      setEventPrices([]);
    }
  };

  const handleChange = async (e) => {
    // const { name, value } = e.target;
    // setForm((prev) => ({ ...prev, [name]: value }));

    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
    setError(""); // reset error saat input berubah

    if (name === "audienceCategory" && value) {
      // Ambil semua detail untuk kategori peserta ini
      try {
        const res = await axios.get(`${apiUrl}/api/public/audience-category-detail/by-category/${value}`);
        const details = Array.isArray(res.data) ? res.data : [res.data].filter(Boolean);
        setCategoryDetails(details);
        setForm((prev) => ({
          ...prev,
          audienceCategoryDetail: details.length === 1 ? String(details[0].id) : "",
        }));
      } catch {
        setCategoryDetails([]);
        setForm((prev) => ({ ...prev, audienceCategoryDetail: "" }));
      }
    }
  }

  useEffect(() => {
    // api.get('/public/audience-category?page=0&size=100')
    //   .then(res => setAudienceCategories(res.data.content));
    api.get('/public/hotel?page=0&size=100')
      .then(res => {
        console.log('Hotels data:', res.data);
        setHotels(res.data.content);
      });
  }, []);


  return (
    <div className="page-wrapper">
      <div className="page-header d-print-none">
        <div className="container-xl">
          <div className="row g-2 align-items-center">
            <div className="col">
              <h2 className="page-title">Event Information</h2>
            </div>
          </div>
        </div>
      </div>
      <div className="page-body">
        <div className="container-xl">
          <div className="card">
            <div className="card-header">
              <form onSubmit={handleSearch} className="d-flex">
                <input
                  type="text"
                  className="form-control me-2"
                  placeholder="Search events..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
                <button type="submit" className="btn btn-primary">Search</button>
              </form>
            </div>
            <div className="table-responsive">
              <table className="table card-table table-vcenter text-nowrap datatable table-hover">
                <thead>
                  <tr>
                    <th>No</th>
                    <th>Event Code</th>
                    <th>Title</th>
                    <th>Start Date</th>
                    <th>End Date</th>
                    <th>Mode</th>
                    <th>Location</th>
                    <th>Status</th>
                    <th>Aksi</th>
                  </tr>
                </thead>
                <tbody>
                  {(events || []).map((event, idx) => (
                    <tr key={event.id}>
                      <td>{idx + 1}</td>
                      <td>{event.eventCode}</td>
                      <td>{event.title}</td>
                      <td>{event.startDate}</td>
                      <td>{event.endDate}</td>
                      <td>{event.mode}</td>
                      <td>
                        <div>{event.locationName}</div>
                        <div className="text-muted">{event.locationAddress}</div>
                      </td>

                      <td>
                        <span className={`badge ${event.isActive ? "bg-success" : "bg-warning"}`}>
                          {event.isActive ? "Aktif" : "Tidak Aktif"}
                        </span>
                      </td>
                      <td>
                        <button
                          className="btn btn-sm btn-primary"
                          onClick={() => handleJoinClick(event)}
                        >
                          Join
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="card-footer d-flex align-items-center">
              <div className="dropdown">
                <a className="btn dropdown-toggle" data-bs-toggle="dropdown">
                  <span id="page-count" className="me-1">{size}</span>
                  <span>records</span>
                </a>
                <div className="dropdown-menu">
                  {[10, 20, 50, 100].map(val => (
                    <a className="dropdown-item" onClick={setPageListItems} data-value={val} key={val}>
                      {val} records
                    </a>
                  ))}
                </div>
              </div>
              <ul className="pagination m-0 ms-auto">
                <li className={`page-item${page === 0 ? ' disabled' : ''}`}>
                  <a className="page-link" href="#" tabIndex="-1" aria-disabled={page === 0}
                    onClick={e => { e.preventDefault(); if (page > 0) setPage(page - 1); }}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                      viewBox="0 0 24 24" fill="none" stroke="currentColor"
                      strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
                      className="icon icon-1">
                      <path d="M15 6l-6 6l6 6" />
                    </svg>
                    prev
                  </a>
                </li>
                {[...Array(totalPages)].map((_, idx) => (
                  <li key={idx} className={`page-item${page === idx ? ' active' : ''}`}>
                    <a className="page-link" href="#" onClick={e => { e.preventDefault(); setPage(idx); }}>
                      {idx + 1}
                    </a>
                  </li>
                ))}
                <li className={`page-item${page === totalPages - 1 ? ' disabled' : ''}`}>
                  <a className="page-link" href="#" aria-disabled={page === totalPages - 1}
                    onClick={e => { e.preventDefault(); if (page < totalPages - 1) setPage(page + 1); }}>
                    next
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                      viewBox="0 0 24 24" fill="none" stroke="currentColor"
                      strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
                      className="icon icon-1">
                      <path d="M9 6l6 6l-6 6" />
                    </svg>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Modal Join */}
      {showJoinModal && (
        <div className="modal modal-blur show d-block" tabIndex="-1">
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  Join Event: {selectedEvent?.title}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowJoinModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                <form onSubmit={handleJoinSubmit}>
                  <div className="row g-3">
                    <div className="col-md-6">
                      <label className="form-label">Nama Lengkap</label>
                      <input
                        type="text"
                        className="form-control"
                        name="nama"
                        value={form.nama}
                        onChange={handleFormChange}
                        required
                      />
                    </div>
                    <div className="col-md-6">
                      <label className="form-label">Nama Lengkap dengan Gelar</label>
                      <input
                        type="text"
                        className="form-control"
                        name="namaLengkapGelar"
                        value={form.namaLengkapGelar}
                        onChange={handleFormChange}
                      />
                    </div>
                    <div className="col-md-6">
                      <label className="form-label">NIK</label>
                      <input
                        type="text"
                        className="form-control"
                        name="nik"
                        value={form.nik}
                        onChange={handleFormChange}
                        required
                      />
                    </div>
                    <div className="col-md-6">
                      <label className="form-label">No HP</label>
                      <input
                        type="tel"
                        className="form-control"
                        name="hp"
                        value={form.hp}
                        onChange={handleFormChange}
                        required
                      />
                    </div>
                    <div className="col-md-6">
                      <label className="form-label">Email</label>
                      <input
                        type="email"
                        className="form-control"
                        name="email"
                        value={form.email}
                        onChange={handleFormChange}
                        required
                      />
                    </div>
                    <div className="col-md-6">
                      <label className="form-label">Asal Institusi</label>
                      <input
                        type="text"
                        className="form-control"
                        name="asalInstitusi"
                        value={form.asalInstitusi}
                        onChange={handleFormChange}
                      />
                    </div>
                    <div className="col-md-6">
                      <label className="form-label">Kategori Peserta</label>
                      <select
                        className="form-select"
                        name="audienceCategory"
                        value={form.audienceCategory}
                        onChange={handleChange}
                        required
                      >
                        <option value="">Pilih Kategori Peserta</option>
                        {audienceCategories.map((cat) => (
                          <option key={cat.id} value={cat.id}>
                            {cat.namaCategory}
                          </option>
                        ))}
                      </select>
                    </div>
                    {/* <div className="col-md-6">
                      <label className="form-label">Event Price</label>
                      <select
                        className="form-select"
                        name="eventPrice"
                        value={form.eventPrice}
                        onChange={handleChange}
                        required
                      >
                        <option value="">Pilih Kategori Event</option>
                        {eventPrices.map((ep) => (
                          <option key={ep.id} value={ep.id}>
                            {ep.namaKategory} - {Number(ep.harga).toLocaleString("id-ID", { style: "currency", currency: "IDR" })}
                          </option>
                        ))}
                      </select>
                    </div> */}

                    {categoryDetails.length > 0 && (
                      <div className="col-md-6">
                        <label className="form-label">Biaya Simposium</label>
                        <select
                          className="form-select"
                          name="audienceCategoryDetail"
                          value={form.audienceCategoryDetail || ""}
                          onChange={handleChange}
                          required
                        >
                          <option value="">Pilih Detail</option>
                          {categoryDetails.map((detail) => (
                            <option key={detail.id} value={detail.id}>
                              {detail.categoryEvent}
                            </option>
                          ))}
                        </select>
                        {form.audienceCategoryDetail && (() => {
                          const selectedDetail = categoryDetails.find(d => String(d.id) === String(form.audienceCategoryDetail));
                          return selectedDetail ? (
                            <>
                              <div className="form-text mt-2">
                                Harga: <strong>{Number(selectedDetail.biayaEvent).toLocaleString("id-ID", { style: "currency", currency: "IDR" })}</strong>
                              </div>
                            </>
                          ) : null;
                        })()}
                      </div>
                    )}


                    {selectedEvent?.id && (
                      <div className="col-12">
                        <WorkshopSelection
                          eventId={selectedEvent.id}
                          form={form}
                          onChange={handleFormChange}
                          onWorkshopsLoaded={setWorkshopCatalog}
                          symposiumFee={
                            categoryDetails.find(
                              (d) => String(d.id) === String(form.audienceCategoryDetail)
                            )?.biayaEvent || 0
                          }
                        />
                      </div>
                    )}

                    {false && form.akomodasiHotel === "ya" && (
                      <>
                        <div className="col-md-6">
                          <label className="form-label">Nama Hotel</label>
                          <select
                            className="form-select"
                            name="hotel"
                            value={form.hotel}
                            onChange={handleHotelChange}
                            required
                          >
                            <option value="">Pilih Hotel</option>
                            {accomodationHotels.map((hotel) => (
                              <option key={hotel.id} value={hotel.id}>
                                {hotel.namaHotel}
                              </option>
                            ))}
                          </select>
                        </div>
                        <div className="col-md-6">
                          <label className="form-label">Tanggal Check-In</label>
                          <input
                            type="date"
                            className="form-control"
                            name="awalInap"
                            value={form.awalInap}
                            onChange={handleFormChange}
                            required
                          />
                        </div>
                        <div className="col-md-6">
                          <label className="form-label">Tanggal Check-Out</label>
                          <input
                            type="date"
                            className="form-control"
                            name="akhirInap"
                            value={form.akhirInap}
                            onChange={handleFormChange}
                            required
                          />
                        </div>
                        <div className="col-md-6">
                          <label className="form-label">Tipe Kamar</label>
                          <select
                            className="form-select"
                            name="typeKamar"
                            value={form.typeKamar}
                            onChange={handleTypeKamarChange}
                            required
                          >
                            <option value="">Pilih Type Kamar</option>
                            {typeKamarOptions.map((type, idx) => (
                              <option key={idx} value={type}>
                                {type}
                              </option>
                            ))}
                          </select>
                        </div>
                        <div className="col-md-6">
                          <label className="form-label">Harga Kamar</label>
                          <div className="form-control-plaintext">
                            {form.hargaKamar
                              ? "Rp " + Number(form.hargaKamar).toLocaleString("id-ID")
                              : "-"}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <label className="form-label">Keterangan</label>
                          <div className="form-control-plaintext">
                            {form.keterangan || "-"}
                          </div>
                        </div>
                      </>
                    )}

                    {/* {categoryDetails.length > 0 && (
                      <div className="col-md-6">
                        <label className="form-label">Biaya Simposium</label>
                        <select
                          className="form-select"
                          name="audienceCategoryDetail"
                          value={form.audienceCategoryDetail || ""}
                          onChange={handleChange}
                          required
                        >
                          <option value="">Pilih Detail</option>
                          {categoryDetails.map((detail) => (
                            <option key={detail.id} value={detail.id}>
                              {detail.categoryEvent}
                            </option>
                          ))}
                        </select>
                        {form.audienceCategoryDetail && (() => {
                          const selectedDetail = categoryDetails.find(d => String(d.id) === String(form.audienceCategoryDetail));
                          return selectedDetail ? (
                            <>
                              <div className="form-text mt-2">
                                Harga: <strong>{Number(selectedDetail.biayaEvent).toLocaleString("id-ID", { style: "currency", currency: "IDR" })}</strong>
                              </div>
                            </>
                          ) : null;
                        })()}
                      </div>
                    )} */}


                  </div>
                  <div className="mt-4 d-flex justify-content-end">
                    <button
                      type="button"
                      className="btn btn-link me-2"
                      onClick={() => setShowJoinModal(false)}
                    >
                      Batal
                    </button>
                    <button type="submit" className="btn btn-primary">
                      Daftar Event Ini
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Confirmation Modal */}
      {showConfirmModal && (
        <div className="modal modal-blur show d-block" tabIndex="-1">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Konfirmasi Pendaftaran</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowConfirmModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                <p>Mohon periksa kembali data pendaftaran Anda:</p>
                <div className="table-responsive">
                  <table className="table table-sm">
                    <tbody>
                      <tr>
                        <td width="30%"><strong>Nama</strong></td>
                        <td>{form.nama}</td>
                      </tr>
                      <tr>
                        <td><strong>Email</strong></td>
                        <td>{form.email}</td>
                      </tr>
                      <tr>
                        <td><strong>Event</strong></td>
                        <td>{selectedEvent?.title || '-'}</td>
                      </tr>
                      <tr>
                        <td><strong>Kategori</strong></td>
                        <td>{audienceCategories.find(cat => String(cat.id) === String(form.audienceCategory))?.namaCategory || '-'}</td>
                      </tr>
                      <tr>
                        <td><strong>Detail Kategori</strong></td>
                        <td>{categoryDetails.find(detail => String(detail.id) === String(form.audienceCategoryDetail))?.categoryEvent || '-'}</td>
                      </tr>
                      <tr>
                        <td><strong>Harga Event</strong></td>
                        <td>
                          {form.audienceCategoryDetail && (() => {
                            const selectedDetail = categoryDetails.find(d => String(d.id) === String(form.audienceCategoryDetail));
                            return selectedDetail && selectedDetail.biayaEvent
                              ? Number(selectedDetail.biayaEvent).toLocaleString("id-ID", { style: "currency", currency: "IDR" })
                              : '-';
                          })()}
                        </td>
                      </tr>
                      <tr>
                        <td><strong>Workshop Sabtu</strong></td>
                        <td>{findWorkshopLabel(workshopCatalog, form.workshopSabtuId)}</td>
                      </tr>
                      <tr>
                        <td><strong>Workshop Minggu</strong></td>
                        <td>{findWorkshopLabel(workshopCatalog, form.workshopMingguId)}</td>
                      </tr>
                      <tr>
                        <td><strong>Biaya Workshop</strong></td>
                        <td>{formatIdr(calcWorkshopFee(form.workshopSabtuId, form.workshopMingguId, workshopCatalog.prices))}</td>
                      </tr>
                      <tr className="table-primary">
                        <td><strong>Total Biaya</strong></td>
                        <td>
                          {(() => {
                            const selectedDetail = categoryDetails.find(d => String(d.id) === String(form.audienceCategoryDetail));
                            const symposium = selectedDetail?.biayaEvent ? Number(selectedDetail.biayaEvent) : 0;
                            const workshop = calcWorkshopFee(form.workshopSabtuId, form.workshopMingguId, workshopCatalog.prices);
                            return formatIdr(symposium + workshop);
                          })()}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className="alert alert-info mt-3">
                  <i className="bi bi-info-circle me-2"></i>
                  Pastikan data yang Anda masukkan sudah benar. Email akan digunakan untuk login dan komunikasi selanjutnya.
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-link link-secondary"
                  onClick={() => setShowConfirmModal(false)}
                >
                  Batalkan
                </button>
                <button
                  type="button"
                  className="btn btn-primary ms-auto"
                  onClick={handleConfirmJoinSubmit}
                >
                  <i className="bi bi-check2 me-2"></i>
                  Ya, Lanjutkan Pendaftaran
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PesertaInfoEvent;